import React from "react";
import imgNotContent from '../../../assets/boy.gif';
import './NotContent.css';

export const  NotContent=()=> {
	return (<div className="not-content-main">
		<img src={imgNotContent} alt="content not search" />
		<img src={imgNotContent} alt="content not search" />
		<img src={imgNotContent} alt="content not search" />
		<img src={imgNotContent} alt="content not search" />
		<img src={imgNotContent} alt="content not search" />
		<img src={imgNotContent} alt="content not search" />
	</div>  );
}

